<template>
    <!-- 门店相册上传图片组件 -->
    <div>
        <a-modal
        centered
        title="上传图片"
        :width="800"
        :maskClosable="false"
        :destroyOnClose="true"
        :visible="visible"
        :confirmLoading="confirmLoading"
        @cancel="cancel"
        @ok="ok"
        >
            <a-form :form="form" >
                <a-form-item label="上传到分组" :labelCol="{span: 3}" :wrapperCol="{span: 8}">
                    <a-select placeholder="请选择" v-decorator="['albumId',{rules: [{required: true, message: '请选择分组',}]}]">
                        <a-select-option :value="item.id" v-for="(item,index) in list" :key="index">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="上传图片" :required="true" :labelCol="{span: 3}" :wrapperCol="{span: 21}">
                    <images-uploader :multiple="true" :selfWidth="true" :limitNum="9999" pxSize="建议尺寸：678*566" ref="imageUpload"></images-uploader>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
    import ImagesUploader from '@/components/common/images-uploader.component';
    export default {
        name: "addAlbum",
        zh: "门店相册上传图片",
        components: {
            ImagesUploader,
        },
        props: {
            list: {
                type: Array,
                default: []
            },
        },
        data() {
            return {
                form: this.$form.createForm(this),
                visible: false,
                confirmLoading: false,
            }
        },
        computed: {},
        watch: {},
        methods: {
            open() {
                this.visible = true;
                this.$nextTick(() => {
                    this.form.setFieldsValue({albumId: this.$route.query.id || '-1'})
                })
            },
            ok() {
                this.form.validateFields((errors, values) => {
                    if (Boolean(errors) || this.confirmLoading) {
                        return false;
                    };
                    this.confirmLoading = true;
                    let itemList = [];
                    this.$refs.imageUpload.fileList.filter(item => item.status === 'done').forEach(item => {
                        itemList.push({
                            displayName: item.name,
                            url: item.url
                        })
                    });
                    if (itemList.length === 0) {
                        this.$message.error('请添加图片')
                        return false
                    }
                    this.$api.storedPhoto.batchAddResource({
                        body: {
                            shopId: this.$route.params.id,
                            albumId: values.albumId,
                            itemList: itemList
                        }
                    }).then(res => {
                        this.confirmLoading = false;
                        this.$message.success('操作成功！');
                        this.cancel();
                    }).catch(err => {
                        this.confirmLoading = false;
                    })
                });
            },
            cancel() {
                this.visible = false;
                this.$refs.imageUpload.fileList = [];
                this.$emit('cancel');
            }
        },
        mounted() {
            // this.getList()
        }
    };
</script>

<style lang="scss">
</style>
